// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b861284","732":"0e448b06","977":"ed362eb0"}[chunkId] + ".chunk.js";
};